import { render, staticRenderFns } from "./appDialog2.vue?vue&type=template&id=2b69273d&scoped=true"
import script from "./appDialog2.vue?vue&type=script&lang=js"
export * from "./appDialog2.vue?vue&type=script&lang=js"
import style0 from "./appDialog2.vue?vue&type=style&index=0&id=2b69273d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b69273d",
  null
  
)

export default component.exports